<template>
  <div :class="{'page-bottom': is_fixed}" style="margin-top:3vw">
    <div class='home_content'>
      <div class='home_title'>
        <img src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_title_icon.png"  class='home-title-icon'>
<!--        <p v-if="isBole">{{$t('home.join_we')}}</p>-->
        <p>JOIN GRANDE GAMES</p>
      </div>
      <div class="msg_content">
<!--        <el-image v-if="isBole && $i18n.locale==='zh'" :src="join_bottom" style=" width: 100%; margin-bottom: 3%"></el-image>-->
<!--        <el-image v-else-if="isBole && $i18n.locale==='en'" :src="join_bottom_en" style=" width: 100%; margin-bottom: 3%"></el-image>-->
        <el-image :src="grande_join_bottom" style=" width: 100%; margin-bottom: 3%"></el-image>
      </div>
    </div>
    <div id="bottom">
<!--      <el-image v-if="isBole && $i18n.locale==='zh'" :src="src" class="bottom-img"></el-image>-->
<!--      <el-image v-else-if="isBole && $i18n.locale==='en'" :src="src_en" class="bottom-img"></el-image>-->
      <el-image :src="grande_bottom_img" class="bottom-img"></el-image>
<!--      <div v-if="isBole" class="beian"><a target="_blank" href="http://beian.miit.gov.cn/publish/query/indexFirst.action">京ICP备20014890号-2</a></div>-->
      <div>
        <a href="https://spinxgames.pactsafe.io/spinx-games#responsible-gaming"  target="_blank" style="color:#8c8b9a;font-weight: 800;text-decoration: revert;">
          Responsible Gaming
        </a>
      </div>
    </div>

  </div>

</template>


<script>
export default {
  data() {
    return {
      src: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/bottom.png',
      src_en: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/bottom_en.png',
      text: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/msg_text.png',
      text_en: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/msg_text_en.png',
      grande_join_bottom:`${require('../assets/img_grande/new_grande_join_bottom.png')}`,
      // grande_bottom_img:`${require('../assets/images_bole/grande_bottom_img.png')}`,
      grande_bottom_img:`${require('../assets/img_grande/grande_bottom.png')}`,
      input: ''
    };
  },
  computed: {
    //英文版首页、关于页，内容不足
    is_fixed() {
      const cur_path = this.$route.path.split('/')[1];
      return false;
      // return cur_path === '' && this.$i18n.locale === 'en' ? true : false
    },
    join_bottom() {
      return 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/bottom_pc.png';
    },
    join_bottom_en() {
      return 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/bottom_pc_en.png';
    },
    isBole() {
      return /bole|localhost/.test(window.location.hostname)
    }
  }
};
</script>

<style lang="less" scoped>
@import url('../assets/style/colors.less');
.beian {
  font-size: 1.2vw;
  color: white;
  padding-bottom: 20px;
  font-family: auto;
  cursor: pointer;
  a {
    text-decoration:none;
    color: #828181;
  }
}
#bottom {
  width: 100%;
  margin: 4vw 0 0 0;
  padding: 2vw 0 1vw;
  background: @lanmu;
  position: relative;
}
.bottom-img {
  width: 70%
}
.msg_content {
  width: 100%;
  // padding: 2.5vw 2.2vw;
  // background: @lanmu;
  position: relative;
  overflow: hidden;
  .msg {
    width: 24vw;
    height: 3.5vw;
    margin-top: 1vw;
    background: white;
    display: flex;
    float: right;
    align-items: center;
    overflow: hidden;
    .msg-input {
      position: relative;
      width: 79%;
      float: left;
    }
    .msg-icon {
      float: right;
      margin-right: 1px;
    }
  }
  .msg_content_intro {
    position: relative;
    float: left;
    width: 50%;
    .msg-text {
      width: 70%;
    }
  }
}
.msg-input {
  display: block;
}
.msg-input-mobile {
  display: none;
}
.over {
  overflow:hidden;
}
.msg-icon-img {
  height: 3vw;
  margin-top: 5px;
}

@media screen and (max-width: 992px) {
  .beian {
    font-size: 12px;
    padding-bottom:2px;
  }
  .home_title p {
    bottom: 2.3vw;
  }
  .home-title-icon {
    height: 6.5vw;
  }
  .msg_content {
    .msg {
      width: 50%;
      height: 5.5vw;
      margin-top: -1vw;
      margin-top: 3vw;
    }
    .msg_content_intro {
      width: 45%;
      .msg-text {
        width: 85%;
      }
    }
  }
  .msg-input {
    display: none;
  }
  .msg-input-mobile {
    display: block;
  }
  .msg-icon-img {
    height: 5vw;
  }
  .bottom-img {
    width: 90%
  }
  .page-bottom {
    bottom: 0;
    margin-top: 3vw;
    position: fixed;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Bottom.vue